export default "__VITE_ASSET__e7b34550__"